import React, { ReactNode } from 'react';
import { Button } from '@mui/material';

interface CustomButtonProps {
    onClick: () => void;
    children: ReactNode;
    disabled?: boolean;
    className?: string; // Added className prop
    type?: 'success' | 'error' | 'warning'; // Added type prop with default value
    fullWidth?: boolean;
}

const CustomButton: React.FC<CustomButtonProps> = ({ onClick, children, disabled, className, type = 'success', fullWidth = false }) => {
    let backgroundColor;

    switch (type) {
        case 'error':
            backgroundColor = '#f44336'; // Red for error
            break;
        case 'warning':
            backgroundColor = '#ff9800'; // Orange for warning
            break;
        case 'success':
        default:
            backgroundColor = '#00897B'; // Green for success
            break;
    }

    return (
        <Button
            onClick={onClick}
            variant="contained"
            className={className} // Added className to Button
            sx={{
                backgroundColor: backgroundColor,
                color: '#ffffff',
                textTransform: 'none',
                width: fullWidth ? '100%' : 'auto',
                '&:hover': {
                    backgroundColor: type === 'success' ? '#99b33d' : type === 'error' ? '#d32f2f' : '#fb8c00',
                },
            }}
            disabled={disabled}
            fullWidth={fullWidth}
        >
            {children}
        </Button>
    );
};

export default CustomButton;
